<div id="content">
  <div class="page-title d-flex align-items-center justify-content-between flex-wrap mb-3">
    <div class="d-flex align-items-center flex-wrap gap-2">
      <a mat-button routerLink="/employees/rrhh/exam-instances">
        <mat-icon>arrow_back</mat-icon>
        Exámenes
      </a>
      <h1 class="mb-0">{{ page_title }}</h1>
    </div>
    <a mat-flat-button color="accent" routerLink="/employees/rrhh/skill-questions/new">
      <mat-icon>add</mat-icon>
      Nueva pregunta
    </a>
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      ></mat-paginator>

      <mat-form-field appearance="outline" class="bisual-paginator-select">
        <mat-label>Skill</mat-label>
        <mat-select formControlName="skill_id" placeholder="Todas">
          <mat-option [value]="null">Todas</mat-option>
          @for (skill of skills(); track skill.id) {
            <mat-option [value]="skill.id">{{ skill.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <input matInput type="text" formControlName="search" placeholder="Buscar..." />
        <button matSuffix mat-icon-button aria-label="Buscar" type="button">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Tipo</th>
          <td mat-cell *matCellDef="let element">{{ element.type_label }}</td>
        </ng-container>

        <ng-container matColumnDef="body">
          <th mat-header-cell *matHeaderCellDef>Enunciado</th>
          <td mat-cell *matCellDef="let element">{{ element.body_excerpt }}</td>
        </ng-container>

        <ng-container matColumnDef="skills">
          <th mat-header-cell *matHeaderCellDef>Skills</th>
          <td mat-cell *matCellDef="let element">{{ element.skills_label }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="actions-cell">
            <div class="table-actions">
              <a mat-icon-button matTooltip="Editar" [routerLink]="['/employees', 'rrhh', 'skill-questions', element.id, 'edit']">
                <mat-icon>edit</mat-icon>
              </a>
              <button mat-icon-button type="button" matTooltip="Eliminar" (click)="deleteSkillQuestion(element)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
